// extracted by mini-css-extract-plugin
export default {"stickyNav":"AppLayout_stickyNav__Ns6xq"};